// extracted by mini-css-extract-plugin
module.exports = {"attachmentsButton":"QuestionAttachments_attachmentsButton__17OHx"};